(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('compendium-special-price', {
            parent: 'entity',
            url: '/compendium-special-price',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Compendium Special Prices'
            },
            ncyBreadcrumb: {
                label: 'Compendium Special Prices',
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/compendium-special-price/compendium-special-prices.html',
                    controller: 'CompendiumSpecialPriceController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('compendium-special-price-detail', {
            parent: 'entity',
            url: '/compendium-special-price/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'CompendiumSpecialPrice'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/compendium-special-price/compendium-special-price-detail.html',
                    controller: 'CompendiumSpecialPriceDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'CompendiumSpecialPrice', function($stateParams, CompendiumSpecialPrice) {
                    return CompendiumSpecialPrice.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'compendium-special-price',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('compendium-special-price-detail.edit', {
            parent: 'compendium-special-price-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/compendium-special-price/compendium-special-price-dialog.html',
                    controller: 'CompendiumSpecialPriceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CompendiumSpecialPrice', function(CompendiumSpecialPrice) {
                            return CompendiumSpecialPrice.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('compendium-special-price.new', {
            parent: 'compendium-special-price',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/compendium-special-price/compendium-special-price-dialog.html',
                    controller: 'CompendiumSpecialPriceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                price: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('compendium-special-price', null, { reload: 'compendium-special-price' });
                }, function() {
                    $state.go('compendium-special-price');
                });
            }]
        })
        .state('compendium-special-price.edit', {
            parent: 'compendium-special-price',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/compendium-special-price/compendium-special-price-dialog.html',
                    controller: 'CompendiumSpecialPriceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CompendiumSpecialPrice', function(CompendiumSpecialPrice) {
                            return CompendiumSpecialPrice.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('compendium-special-price', null, { reload: 'compendium-special-price' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('compendium-special-price.delete', {
            parent: 'compendium-special-price',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/compendium-special-price/compendium-special-price-delete-dialog.html',
                    controller: 'CompendiumSpecialPriceDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['CompendiumSpecialPrice', function(CompendiumSpecialPrice) {
                            return CompendiumSpecialPrice.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('compendium-special-price', null, { reload: 'compendium-special-price' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
